<template>
  <div class="ai-fab" @click="togglePanel">
    <img class="ai-icon" src="@/assets/icons/ai.svg" alt="AI" />
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class AiChatEntry extends Vue {
  togglePanel() {
    if (!this.$store.state.aiChat.visible) {
      this.$store.commit('openAiChat');
    } else {
      this.$store.commit('closeAiChat');
    }
  }
}
</script>

<style scoped lang="scss">
.ai-fab {
  position: absolute;
  right: 0;
  bottom: 20px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 56px;
  height: 48px;
  padding: 8px 12px;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  background: linear-gradient(134.58deg, #9bc9ff 14.23%, #b95dff 85.04%);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
  }
}

.ai-icon {
  width: 32px;
  height: 32px;
}
</style>
